import Component from './component'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {editarPaginaSite, adicionarNovaPaginaSite, removerPaginaSite} from '../../../actions/paginas'
import { showSnack } from 'react-redux-snackbar';

const mapStateToProps = (state) => ({
    paginas : state.database.paginas
})

const mapDispatch = (dispatch) =>({
    novo : (a,b) => dispatch(adicionarNovaPaginaSite(a,b)),
    editar : (a,b,c) => dispatch(editarPaginaSite(a,b,c)),
    delete : (id) => dispatch(removerPaginaSite(id)),
    feedback : (message) => dispatch(showSnack(Date.now(), {
        label : message,
        timeout : 5000,
        button : {label : 'Beleza'}
    }))
})

export default withRouter(connect(mapStateToProps, mapDispatch)(Component))


// WEBPACK FOOTER //
// ./src/views/administrativo/editor/container.js